import { AUTH_ROUTE_ID } from '@/integrations/tanstack-router/auth-route-id';

export const INIS_ROUTES = {
  index: '/my-patient',
  dailyCare: '/daily-care',
  assessmentForms: '/assessment-forms',
  patientEducation: '/patient-education',
} as const;

export const INIS_LAYOUT_ROUTE_ID = 'inis-layout' as const;

const INIS_LAYOUT_FULL_ROUTE_ID =
  `/${AUTH_ROUTE_ID}/${INIS_LAYOUT_ROUTE_ID}` as const;

export const INIS_ROUTE_IDS = {
  index: `/${AUTH_ROUTE_ID}${INIS_ROUTES.index}`,
  inisLayout: INIS_LAYOUT_FULL_ROUTE_ID,
  dailyCare: `${INIS_LAYOUT_FULL_ROUTE_ID}${INIS_ROUTES.dailyCare}`,
  assessmentForms: `${INIS_LAYOUT_FULL_ROUTE_ID}${INIS_ROUTES.assessmentForms}`,
  patientEducation: `${INIS_LAYOUT_FULL_ROUTE_ID}${INIS_ROUTES.patientEducation}`,
} as const;
